require('./helpers/bundle-manifest').register(JSON.parse("{\"6T0cF\":\"index.fec3b324.js\",\"7jMZW\":\"logo.51bc2a05.png\",\"bFJtZ\":\"index.b60789f3.css\"}"));